import {Component, Input, HostBinding} from '@angular/core';

import {RouterModule} from '@angular/router';

@Component({
  selector: 'ui-list-item',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './ui-list-item.component.html',
  styleUrl: './ui-list-item.component.scss'
})
export class UiListItemComponent {
  /**
   * Enable hover effect
   */
  @Input() hoverable = true;

  /**
   * Make the item clickable (adds cursor pointer)
   */
  @Input() clickable = false;

  /**
   * Active state
   */
  @Input() active = false;

  /**
   * Compact padding
   */
  @Input() compact = false;

  @HostBinding('class')
  get hostClasses(): string {
    const classes: string[] = [
      'w-full',
      'block',
      'transition-colors',
      'duration-150',
      // focus ring (works when host becomes focusable via routerLink on host)
      'focus:outline-none',
      'focus-visible:ring-2',
      'focus-visible:ring-primary/40',
      'focus-visible:ring-offset-2',
      'focus-visible:ring-offset-base-100'
    ];

    const hoverEnabled = this.hoverable;

    // If inside UiList, allow list-level toggles to control behavior
    // (these marker classes are added on the UiList container)
    classes.push('[.ui-list--compact_&]:py-2', '[.ui-list--compact_&]:px-3');
    classes.push('[.ui-list--hoverable_&]:hover:bg-base-200');

    if (hoverEnabled) {
      classes.push('hover:bg-base-200');
    }

    if (this.clickable) {
      classes.push('cursor-pointer');
    }

    if (this.active) {
      classes.push('bg-base-200');
    }

    if (this.compact) {
      classes.push('py-2', 'px-3');
    } else {
      classes.push('py-3', 'px-4');
    }

    return classes.join(' ');
  }
}
